<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="chapter-title">
      Перечень специальных журналов работ
    </div>
    <n-table :columns="columns" :data="data">
      <template #endedAt="{item}">
        {{ $app.date.format(item.endedAt) }}
      </template>
      <template #company="{item}">
        ТОО "DIRECT CONSTRUCTION SERVICE" <span style="opacity: .8;font-size: .8em">[050440002386]</span>
      </template>
      <template #tools="{item}">
        <n-link :to="{name:'journals.index', params:{ journal: item.name, projectId: project.id, }}"><n-button icon="eye" /></n-link>
      </template>
    </n-table>
  </div>
</template>

<script>
export default {
  name: 'MainChapter5',
  props: [ 'project', ],
  data: () => ({
    columns: [
      { name: 'title', title: 'Наименование специального журнала работ и дата его выдачи', },
      { name: 'company', title: 'Организация, ведущая специальный журнал работ, должность, фамилия, инициалы ответственного лица', },
      { name: 'endedAt', title: 'Дата сдачи-приемки специального журнала работ и подпись должностного лица', },
      { name: 'tools', title: '', },
    ],
    data: [],
  }),
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.get(this.project.id).filter({ tag: 'spec', }).then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
